import { render, staticRenderFns } from "./requirementDetails.vue?vue&type=template&id=7bdc6faa&scoped=true"
import script from "./requirementDetails.vue?vue&type=script&lang=js"
export * from "./requirementDetails.vue?vue&type=script&lang=js"
import style0 from "./requirementDetails.vue?vue&type=style&index=0&id=7bdc6faa&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdc6faa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bdc6faa')) {
      api.createRecord('7bdc6faa', component.options)
    } else {
      api.reload('7bdc6faa', component.options)
    }
    module.hot.accept("./requirementDetails.vue?vue&type=template&id=7bdc6faa&scoped=true", function () {
      api.rerender('7bdc6faa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GuoJiao/requirementAnalysis/requirementDetails.vue"
export default component.exports